<template>
  <main class="main-layout">
    <section class="main-layout__content">
      <router-view v-slot="{ Component, route }">
        <component :is="Component" :key="route.path" />
      </router-view>
    </section>

    <van-tabbar
      :model-value="activeTab"
      fixed
      safe-area-inset-bottom
      active-color="var(--wp-color-theme)"
      inactive-color="#999999"
      class="main-tabbar"
      @change="handleTabChange"
    >
      <van-tabbar-item name="home">
        <template #icon="{ active }">
          <AppSvgIcon
            class="main-tabbar__icon"
            name="vector"
            size="20"
            :color="active ? 'var(--wp-color-brand-1)' : '#999999'"
          />
        </template>
        {{ t('tab.home') }}
      </van-tabbar-item>

      <van-tabbar-item name="card">
        <template #icon="{ active }">
          <AppSvgIcon
            class="main-tabbar__icon"
            name="bank"
            size="20"
            :color="active ? 'var(--wp-color-brand-1)' : '#999999'"
          />
        </template>
        {{ t('tab.card') }}
      </van-tabbar-item>

      <van-tabbar-item name="mine">
        <template #icon="{ active }">
          <AppSvgIcon
            class="main-tabbar__icon"
            name="group"
            size="20"
            :color="active ? 'var(--wp-color-brand-1)' : '#999999'"
          />
        </template>
        {{ t('tab.mine') }}
      </van-tabbar-item>
    </van-tabbar>
  </main>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const tabRouteMap = {
  home: '/home/index',
  card: '/home/card',
  mine: '/home/mine'
};

const activeTab = computed(() => {
  if (route.path.startsWith('/home/card')) {
    return 'card';
  }
  if (route.path.startsWith('/home/mine')) {
    return 'mine';
  }
  return 'home';
});

function handleTabChange(name) {
  const target = tabRouteMap[name] || '/home/index';
  if (route.path === target) {
    return;
  }
  router.push(target);
}
</script>

<style scoped lang="scss">
.main-layout {
  display: flex;
  flex-direction: column;
  height: var(--app-viewport-height);
  min-height: var(--app-viewport-height);
  background: #fff;
  overflow: hidden;
}

.main-layout__content {
  flex: 1;
  min-height: 0;
  padding-bottom: calc(0px + env(safe-area-inset-bottom));
  overflow: hidden;

  ::deep(.van-overlay) {
    background: #ffffff !important;
  }
}

.main-tabbar {
  height: 68px;
  border-top: 0;
  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.1);
  z-index: 1000;

  :deep(.van-tabbar-item) {
    font-size: 14px;
    font-weight: 400;
  }

  :deep(.van-tabbar-item--active) {
    font-weight: 500;
    background: #ffffff;
  }
}

.main-tabbar__icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}
</style>
